import StarIcon from "../../../images/icons/starIcon";
import ImageComponent from "../shared/ImageComponent";
import NoProfile from "../../../images/profileImage.png";
import {Link} from "react-router-dom";
import ZipCodeIcon from "../../../images/icons/zipCode";
import CategoryIcon from "../../../images/icons/CategoryIcon";
import {
  interventionStatus,
  offerStatus,
  proposalStatus,
  userRoleList,
} from "../../../utils/constants";
import {getOfferStatusColor} from "../../../utils/status";
import {useState} from "react";
import ProposalModal from "./proposalModal";
import {useProposal} from "../../../hooks/useProposal";
import {
  combineFrenchDateAndTime,
  formatFrenchDateInput,
  formatFrenchTimeInput,
  interventionDate,
  proposalDate,
} from "../../../utils/date";
import {useTranslation} from "react-i18next";
import {Dropdown} from "react-bootstrap";
import DropdownToggle from "react-bootstrap/esm/DropdownToggle";
import DropdownMenu from "react-bootstrap/esm/DropdownMenu";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import {generatePrettyUrl} from "../../../utils/prettyUrl";
import ProposalTimeLineModal from "./ProposalTimeLine";
import {useUpdateIntervention} from "../../../hooks/useInterventions";
import {useUpdateTechnician} from "../../../hooks/useUpdateUser";
import AddressModal from "./AddressModal";
import RecapModal from "./RecapModal";
import {set} from "react-hook-form";
import "./proposalStyle.css";
import BlockModal from "../shared/blockModal";
import CertainModal from "../shared/CertainModal";
import {useChatRoom} from "../../../hooks/useChat";
import {isProposalPayable} from "../../../utils/proposalPresentation";

const ChatHeader = ({conversation, role, setIsSidebarOpen, ConnectedUser}) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [isModalBlockOpen, setModalBlockOpen] = useState(false);
  const [isModalViewOpen, setModalViewOpen] = useState(false);
  const [isModalAdressOpen, setModalAdressOpen] = useState(false);
  const [isModalModifOpen, setModalModifOpen] = useState(false);
  const [isModalRecapOpen, setModalRecapOpen] = useState(false);
  const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);
  const [isRefuseConfirmOpen, setIsRefuseConfirmOpen] = useState(false);
  const [proposalToRefuseId, setProposalToRefuseId] = useState(null);
  const {
    onAddProposal,
    onUpdateProposal,
    onDeleteProposal,
    onAcceptProposal,
    onRefuseProposal,
    onAddProposalNoOffer,
    onAcceptWithAdress,
    openPayment,
  } = useProposal();

  const {onDeleteRoom} = useChatRoom();

  const {onBlockUser} = useUpdateTechnician();
  const {t} = useTranslation();

  const blocked = conversation?.blocked;
  const endUser =
    role === userRoleList.TECHNICIAN
      ? {
          ...conversation?.Client?.User,
          endUserId: conversation?.Client?.id,
          role: userRoleList.CLIENT,
        }
      : {
          ...conversation?.Technician?.User,
          endUserId: conversation?.Technician?.id,
          role: userRoleList.TECHNICIAN,
        };
  const offer = conversation?.indirectChat?.offer;
  const proposals = conversation?.direct
    ? conversation?.directChat?.propositions
    : !!offer?.Offer_Proposals?.length
      ? offer?.Offer_Proposals.filter(
          (el) => el.technicianId === conversation.technicianId,
        )
      : [];
  const proposal = !!proposals?.length ? proposals[proposals.length - 1] : null;
  const [selectedProposal, setSelectedProposal] = useState(proposal);

  const requestProposalRefusal = (proposalId) => {
    setModalViewOpen(false);
    setProposalToRefuseId(proposalId);
    setTimeout(() => setIsRefuseConfirmOpen(true), 150);
  };

  const confirmProposalRefusal = () => {
    const proposalId = proposalToRefuseId;
    setIsRefuseConfirmOpen(false);
    setProposalToRefuseId(null);
    if (proposalId) onRefuseProposal(proposalId);
  };

  const openAcceptedProposalRecap = (acceptanceData = {}) => {
    setSelectedProposal((currentProposal) =>
      currentProposal
        ? {
            ...currentProposal,
            ...acceptanceData,
            status: proposalStatus.ACCEPTED,
          }
        : currentProposal,
    );
    setModalRecapOpen(true);
  };

  const {bg, color} = getOfferStatusColor({status: offer?.status});
  const handlePropositionSubmit = (values) => {
    // Add your API call or state update logic here
    const {appointmentDate, appointmentTime} = values;

    // Combine date and time into ISO 8601 format
    const combinedDateTime = combineFrenchDateAndTime(
      appointmentDate,
      appointmentTime,
    ).toISOString();

    if (!conversation?.direct) {
      onAddProposal({
        initialBudget: values.initialPrice,
        appointmentDate: combinedDateTime,
        comment: values.comment,
        title: values.title,
        offerId: offer?.id,
      });
    } else {
      onAddProposalNoOffer({
        initialBudget: values.initialPrice,
        appointmentDate: combinedDateTime,
        comment: values.comment,
        title: values.title,
        clientId: conversation?.Client?.id,
        directChatId: conversation?.directChat?.id,
      });
    }
  };

  const handlePropositionUpdateSubmit = (values) => {
    // Add your API call or state update logic here
    const {appointmentDate, appointmentTime} = values;

    // Combine date and time into ISO 8601 format
    const combinedDateTime = combineFrenchDateAndTime(
      appointmentDate,
      appointmentTime,
    ).toISOString();

    onUpdateProposal({
      id: proposal?.id,
      initialBudget: values.initialPrice,
      appointmentDate: combinedDateTime,
      comment: values.comment,
      title: values.title,
    });
  };

  const getButtonTitle = () => {
    if (proposal?.Intervention?.status === interventionStatus.CANCELED) {
      return {
        bg: "#FFF0F2",
        color: "#D80027",
        text: "interventionCanceled",
      };
    }

    switch (proposal?.status) {
      case proposalStatus.REFUSED:
        if (role === userRoleList.CLIENT)
          return {
            bg: "#D800271A",
            color: "#D80027",
            text: "proposalRefusedClient",
          };
        return {
          bg: "#D800271A",
          color: "#D80027",
          text: "proposalRefusedTech",
        };

      case proposalStatus.CANCELLED:
        if (role === userRoleList.CLIENT)
          return {
            bg: "#FFF0F2",
            color: "#D80027",
            text: "proposalCancelledClient",
          };
        return {
          bg: "#FFF0F2",
          color: "#D80027",
          text: "proposalCancelledTech",
        };

      case proposalStatus.ACCEPTED:
        if (role === userRoleList.CLIENT)
          return {
            bg: "#FF66001A",
            color: "#FF6600",
            text: "proposalAcceptedClient",
          };
        return {
          bg: "#FF66001A",
          color: "#FF6600",
          text: "proposalAcceptedTech",
        };

      case proposalStatus.OFFER_HANDLED:
        if (role === userRoleList.CLIENT)
          return {
            bg: "#D800271A",
            color: "#D80027",
            text: "proposalHandledClient",
          };
        return {
          bg: "#D800271A",
          color: "#D80027",
          text: "proposalHandledTech",
        };
      // if (role === userRoleList.CLIENT)
      //   return {
      //     bg: "#D800271A",
      //     color: "#D80027",
      //     text: "proposalRefusedClient",
      //   };
      // return {
      //   bg: "#D800271A",
      //   color: "#D80027",
      //   text: "proposalRefusedTech",
      // };

      case proposalStatus.ENDED:
        if (role === userRoleList.CLIENT)
          if (role === userRoleList.CLIENT)
            return {
              bg: "#27AA001A",
              color: "#27AA00",
              text: "proposalEndedClient",
            };
        return {
          bg: "#27AA001A",
          color: "#27AA00",
          text: "proposalEndedTech",
        };
      //   return {
      //     bg: "#19295C1A",
      //     color: "#19295C",
      //     text: "proposalEndedClient",
      //   };
      // return {
      //   bg: "#19295C1A",
      //   color: "#19295C",
      //   text: "proposalEndedTech",
      // };

      case proposalStatus.INTERVENTION_CREATED:
        if (role === userRoleList.CLIENT)
          return {
            bg: "#27AA001A",
            color: "#27AA00",
            text: "proposalInterventionCreatedClient",
          };
        return {
          bg: "#27AA001A",
          color: "#27AA00",
          text: "proposalInterventionCreatedTech",
        };

      case proposalStatus.INTERVENTION_DECLINED:
        if (role === userRoleList.CLIENT)
          return {
            bg: "#FFF0F2",
            color: "#D80027",
            text: "proposalInterventionDeclinedClient",
          };
        return {
          bg: "#FFF0F2",
          color: "#D80027",
          text: "proposalInterventionDeclinedTech",
        };
      // if (role === userRoleList.CLIENT)
      //   return {
      //     bg: "#D800271A",
      //     color: "#D80027",
      //     text: "proposalInterventionDeclinedClient",
      //   };
      // return {
      //   bg: "#D800271A",
      //   color: "#D80027",
      //   text: "proposalInterventionDeclinedTech",
      // };

      default:
        if (role === userRoleList.CLIENT)
          return {
            bg: "#FFF2EA",
            color: "#FF6600",
            text: "proposalWaitingClient",
          };
        return {
          bg: "#FFF2EA",
          color: "#FF6600",
          text: "proposalWaitingTech",
        };
    }
  };

  return (
    <div
      className={`w-full flex-col h-fit rounded-b-2xl bg-[#E8F3FF] ${
        !!proposal ? "bg-[#E8F3FF]" : ""
      }`}
    >
      <div className=" bg-[#1A64B9] border-b flex items-center  rounded-b-2xl">
        <ProposalTimeLineModal
          isOpen={isModalViewOpen}
          onClose={() => setModalViewOpen(false)}
          proposals={proposals}
          setModalRecapOpen={(open) => {
            if (open) setModalViewOpen(false);
            setModalRecapOpen(open);
          }}
          direct={conversation?.direct}
          onRefuseProposal={requestProposalRefusal}
          setModalAdressOpen={(open) => {
            if (open) setModalViewOpen(false);
            setModalAdressOpen(open);
          }}
          setSelectedProposal={setSelectedProposal}
          role={role}
        />
        <RecapModal
          isOpen={isModalRecapOpen}
          onClose={() => setModalRecapOpen(false)}
          initialValues={{
            title: selectedProposal?.title ?? "",
            appointmentDate: !!selectedProposal?.appointmentDate
              ? interventionDate(selectedProposal?.appointmentDate)
              : "",
            adresse: selectedProposal?.address ?? offer?.address ?? "",
            initialPrice: selectedProposal?.initialBudget ?? "",
            comment: selectedProposal?.comment ?? "",
            status: selectedProposal?.status,
            id: selectedProposal?.id,
          }}
          onSubmit={() => {
            setModalRecapOpen(false);
            onAcceptProposal(selectedProposal?.id, {
              onAccepted: openAcceptedProposalRecap,
            });
          }}
          onPayment={async () => {
            setModalRecapOpen(false);
            await openPayment(selectedProposal?.id);
          }}
        />
        <AddressModal
          initialValues={{
            title: selectedProposal?.title ?? "",
            appointmentDate: !!selectedProposal?.appointmentDate
              ? interventionDate(selectedProposal?.appointmentDate)
              : "",
            initialPrice: selectedProposal?.initialBudget ?? "",
            comment: selectedProposal?.comment ?? "",

            address: ConnectedUser?.address ?? "",
            postCode: ConnectedUser?.zipCode ?? "",
            ville: ConnectedUser?.city ?? "",
          }}
          isOpen={isModalAdressOpen}
          onClose={() => setModalAdressOpen(false)}
          id={selectedProposal?.id}
          onAccept={onAcceptWithAdress}
          onAccepted={openAcceptedProposalRecap}
        />
        <ProposalModal
          modif={false}
          initialValues={{
            title: "",
            appointmentDate: "",
            initialPrice: "",
            appointmentTime: "",
            comment: "",
          }}
          isOpen={isModalOpen}
          onClose={() => setModalOpen(false)}
          onSubmit={handlePropositionSubmit}
        />
        <CertainModal
          show={isRefuseConfirmOpen}
          setShow={setIsRefuseConfirmOpen}
          handelButton={confirmProposalRefusal}
          title={'Refuser la proposition ?'}
          message={
            'Voulez-vous vraiment refuser cette proposition ? Cette action sera notifiée au prestataire.'
          }
          buttonTitle={'Refuser'}
          secondButtonTitle={'Annuler'}
        />
        <CertainModal
          show={isModalDeleteOpen}
          setShow={setIsModalDeleteOpen}
          handelButton={() => {
            onDeleteRoom({id: conversation?.id});
          }}
          message={
            "Tous les messages de cette conversation vont être supprimé définitivement. Voulez-vous vraiment continuer?"
          }
          title={"Suppression de la conversation"}
          buttonTitle={"Oui"}
          secondButtonTitle={"Non"}
        />
        <BlockModal
          show={isModalBlockOpen}
          setShow={setModalBlockOpen}
          handleButton={() => {
            onBlockUser({blockedId: endUser?.id});
            setModalBlockOpen(false);
          }}
          title={`Bloquer ${endUser.firstName} `}
          message={`${
            endUser.role === userRoleList.CLIENT
              ? "Bloquer cet utilisateur l'empêchera de vous contacter ou de voir votre profil. Confirmez-vous ?"
              : "Bloquer cet utilisateur l'empêchera de vous contacter ou de voir vos annonces. Confirmez-vous ?"
          } `}
        />
        <ProposalModal
          modif={true}
          initialValues={{
            title: proposal?.title ?? "",
            initialPrice: proposal?.initialBudget ?? "",
            appointmentDate: !!proposal?.appointmentDate
              ? formatFrenchDateInput(proposal.appointmentDate)
              : "",
            appointmentTime: !!proposal?.appointmentDate
              ? formatFrenchTimeInput(proposal.appointmentDate)
              : "",
            comment: proposal?.comment ?? "",
          }}
          isOpen={isModalModifOpen}
          onClose={() => setModalModifOpen(false)}
          onSubmit={handlePropositionSubmit}
        />

        <div
          className=" p-2 h-full bg-none text-lg flex items-center justify-center text-white border-r border-solid border-[#3F87DA]  lg:hidden"
          onClick={() => setIsSidebarOpen(true)}
        >
          <i className="fi fi-rr-arrow-to-right flex items-center"></i>
        </div>
        <div className="py-6 !px-2 lg:!px-4 xl:!px-9  h-full flex justify-start items-center gap-3  lg:border-r border-solid border-[#3F87DA] ">
          <Link
            to={
              endUser.role === userRoleList.TECHNICIAN
                ? "/prestataire/" + endUser.endUserId
                : "/client/" + endUser.endUserId
            }
            className="relative min-w-[50px] "
          >
            {!!endUser?.avgRating && (
              <Link
                onClick={(e) => {
                  e.stopPropagation();
                }}
                to={
                  endUser.role === userRoleList.TECHNICIAN
                    ? "/prestataire/" + endUser.endUserId + "/#avis"
                    : "/client/" + endUser.endUserId
                }
                className="bg-[#FFC107] w-[30px] flex justify-center gap-[2px] items-center leading-none p-[1px] text-white text-[7px] absolute bottom-0 rounded-md left-[50%] -translate-x-[50%] "
              >
                {Number(endUser?.avgRating).toFixed(2) ?? "--"}
                <StarIcon className="fill-white stroke-none w-2 h-2" />
              </Link>
            )}
            <ImageComponent
              src={buildImageUrl(endUser?.imageUri)}
              alt=""
              className=" w-16 aspect-square rounded-full object-cover"
              fallback={
                <img
                  src={NoProfile}
                  alt=""
                  className=" w-16 aspect-square rounded-full object-cover"
                  width="130"
                />
              }
            />
          </Link>
          <div className="hidden  lg:flex text-left flex-col justify-center items-start">
            <Link
              to={
                endUser.role === userRoleList.TECHNICIAN
                  ? "/prestataire/" + endUser.endUserId
                  : "/client/" + endUser.endUserId
              }
              className="text-white md font-semibold lg:font-bold text-sm lg:text-base capitalize"
            >
              {`${endUser?.lastName} ${endUser?.firstName}`}
            </Link>
            <div className="text-[#FF6600] font-normal text-sm ">
              {role === userRoleList.TECHNICIAN ? "Client" : "Prestataire"}
            </div>
          </div>
        </div>

        <div
          className={`flex   flex-grow !py-5 !px-5 xl:!px-10  ${
            !!offer
              ? "!justify-between flex-row  items-center"
              : "justify-end items-center"
          }`}
        >
          {!!offer && (
            <div className="flex flex-col flex-grow justify-center items-start gap-2">
              <div className="flex items-center justify-start    w-4/5 line-clamp-1">
                <Link
                  data-i18n-skip
                  title={offer?.title}
                  to={"/annonce/" + generatePrettyUrl(offer?.id, offer?.title)}
                  className="text-white  font-semibold text-xs lg:text-[16px]  capitalize-first line-clamp-1  "
                >
                  {offer?.title}
                </Link>
                <div className="w-5 flex justify-center items-center">
                  <div
                    className={`w-2 h-2 rounded-full ring-[1px] ring-white `}
                    style={{backgroundColor: color}}
                  >
                    {" "}
                  </div>
                </div>
              </div>

              <div className="flex w-full justify-start items-center gap-4">
                <div className="flex justify-start items-center gap-2  text-white font-bold text-xs lg:text-[15px]">
                  <ZipCodeIcon className="w-4 h-4 fill-[white]" />{" "}
                  {offer?.postCode ?? "--"}
                </div>
                {/* <div className="flex justify-start items-center gap-2  text-white font-bold text-[15px]">
              <CategoryIcon className="w-4 h-4 fill-white" />{" "}
              {offer?.SubCategories[0]?.Category?.title ?? "--"}
            </div> */}
              </div>

              <div className=" text-primary font-semibold text-xs lg:text-[16px] flex items-center gap-3 text-nowrap mr-[70px]">
                {offer?.minBudget}€ - {offer?.maxBudget}€{" "}
              </div>
            </div>
          )}
          <div
            className={`flex  w-fit items-center justify-end  ${
              !!offer ? "" : "justify-end"
            } gap-3 lg:gap-5 xl:gap-10 text-white`}
          >
            {(((!proposal ||
              [
                proposalStatus.REFUSED,
                proposalStatus.CANCELLED,
                proposalStatus.HIDDEN,
              ].includes(proposal?.status)) &&
              offer?.status === offerStatus.PUBLIC) ||
              !offer) &&
              role === userRoleList.TECHNICIAN && (
                <button
                  disabled={blocked}
                  onClick={() => {
                    if (!proposal) {
                      setModalOpen(true);
                    } else {
                      setModalModifOpen(true);
                    }
                  }}
                  className="bg-[#FF6600] font-bold text-sm text-white px-1 xl:!px-4 py-2 !rounded-lg hidden sm:flex items-center gap-2"
                >
                  <i className="fi fi-rr-handshake hidden items-center xl:flex"></i>
                  <span className="  ">Faire une proposition</span>
                </button>
              )}
            <Dropdown>
              <DropdownToggle
                variant=""
                className=" i-false !p-0 font-bold text-lg text-white "
              >
                <i className="fi fi-rr-menu-dots-vertical flex items-center"></i>
              </DropdownToggle>
              <DropdownMenu align="right" className="w-[150px] p-0 !rounded-md">
                <Dropdown.Item>
                  <div
                    onClick={() => {
                      setModalBlockOpen(true);
                    }}
                    className="cursor-pointer dropdown-item group !px-4 border-b font-semibold hover:bg-[#EFF2F7] !text-[#3D4465] hover:!text-[#3D4465] text-sm"
                  >
                    Bloquer
                  </div>
                </Dropdown.Item>
                {![proposalStatus.INITIATED, proposalStatus.ACCEPTED].includes(
                  proposal?.status,
                ) && (
                  <Dropdown.Item>
                    <div
                      onClick={() => {
                        setIsModalDeleteOpen(true);
                      }}
                      className="cursor-pointer dropdown-item group !px-4 border-b font-semibold hover:bg-[#EFF2F7] !text-[#3D4465] hover:!text-[#3D4465] text-sm"
                    >
                      Supprimer
                    </div>
                  </Dropdown.Item>
                )}
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
      </div>
      {(window.innerWidth < 640 || !!proposal) && (
        <div className="animate-slide-down">
          {!!proposal && (
            <div
              className="hidden items-center justify-between w-full px-6 py-3 cursor-pointer gap-2 flex-wrap lg:flex "
              onClick={() => setModalViewOpen(true)}
            >
              <div className="flex items-center justify-start gap-6 text-[15px] leading-[15px]  font-medium text-[#3D4465] flex-wrap ">
                <div> {proposal?.title} </div>
                <div className="flex items-center gap-2">
                  <span className="text-[#1A64B9]">
                    <i className="fi fi-rr-calendar flex items-center"></i>
                  </span>
                  {proposalDate(proposal?.appointmentDate)}
                </div>
                <div className="flex items-center gap-1">
                  Prix proposé :
                  <span className="text-[#FF6600] font-semibold">
                    {proposal?.initialBudget} €
                  </span>
                </div>
              </div>
              <div className="flex items-center justify-end gap-4 text-[15px] leading-[15px] text-[#1A64B9] flex-wrap ">
                <div
                  style={{
                    color: getButtonTitle().color,
                    backgroundColor: getButtonTitle().bg,
                  }}
                  className={` px-3 py-2 rounded-full `}
                >
                  {t(getButtonTitle().text)}
                </div>
                {role === userRoleList.TECHNICIAN &&
                  [proposalStatus.INITIATED, proposalStatus.HIDDEN].includes(
                    proposal?.status,
                  ) && (
                    <>
                      <div
                        className="w-6 h-6 bg-[#FFCACA] text-[#FF0000] flex justify-center items-center rounded-full cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent click event from bubbling up
                          onDeleteProposal(proposal?.id);
                        }}
                      >
                        <i className="fi fi-rr-trash flex items-center"></i>
                      </div>
                    </>
                  )}
                {role === userRoleList.CLIENT &&
                  ([proposalStatus.INITIATED].includes(proposal?.status) ? (
                    <>
                      <button
                        className="p-2 min-w-[100px]  !rounded-lg bg-white !text-[#0D44B1] !border-[#0D44B1] !border  border-solid "
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent click event from bubbling up
                          requestProposalRefusal(proposal?.id);
                        }}
                      >
                        Refuser
                      </button>
                      <button
                        className="p-2 min-w-[100px]   !rounded-lg bg-gradient-to-r from-[#0022AA] to-[#1A64B9] text-white "
                        onClick={(e) => {
                          setSelectedProposal(proposal);
                          e.stopPropagation();
                          if (conversation?.direct) {
                            setModalAdressOpen(true);
                          } else {
                            setModalRecapOpen(true);
                          }
                        }}
                      >
                        Accepter
                      </button>
                    </>
                  ) : isProposalPayable(proposal) ? (
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedProposal(proposal);
                        setModalRecapOpen(true);
                      }}
                      className="p-2 min-w-[100px]   !rounded-lg bg-gradient-to-r from-[#0022AA] to-[#1A64B9] text-white "
                    >
                      Payer
                    </button>
                  ) : null)}
              </div>
            </div>
          )}

          <div
            className="flex items-center justify-between text-[#19295C] w-full px-3 py-3 cursor-pointer gap-2 flex-wrap  lg:hidden"
            onClick={() => {
              if (!!proposal) {
                setModalViewOpen(true);
              } else {
                return;
              }
            }}
          >
            {!!proposal && (
              <span className="underline">Voir les propositions</span>
            )}
            <div className="flex-grow  sm:hidden flex justify-end items-center">
              {(((!proposal ||
                [
                  proposalStatus.REFUSED,
                  proposalStatus.CANCELLED,
                  proposalStatus.HIDDEN,
                ].includes(proposal?.status)) &&
                offer?.status === offerStatus.PUBLIC) ||
                !offer) &&
                role === userRoleList.TECHNICIAN && (
                  <button
                    disabled={blocked}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (!proposal) {
                        setModalOpen(true);
                      } else {
                        setModalModifOpen(true);
                      }
                    }}
                    className="bg-[#FF6600] font-bold text-sm text-white px-1 xl:!px-4 py-2 !rounded-lg flex items-center gap-2"
                  >
                    <i className="fi fi-rr-handshake hidden items-center xl:flex"></i>
                    <span className="!no-underline text-xs ">
                      Faire une proposition
                    </span>
                  </button>
                )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatHeader;
